import { INIT_PAGINATION } from '@spx-portal/shared-utils';
import { useMemo, useState } from 'react';
import { PaginationProps } from 'ssc-ui-react/typings/components/pagination/types';
const defaultPagination = {
  ...INIT_PAGINATION,
  showQuickJumper: false,
};

export const useBatchData = () => {
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [pagination, setPagination] = useState<PaginationProps>(defaultPagination);
  const [summary, setSummary] = useState<any>({});
  const list = useMemo(() => {
    const current = pagination.current ?? 1;
    const pageSize = pagination.pageSize ?? 20;
    return dataSource.slice((current - 1) * pageSize, (current) * pageSize);
  }, [dataSource, pagination]);
  return {
    dataSource,
    setDataSource,
    pagination,
    setPagination,
    summary,
    setSummary,
    list,
  };
};
